import { lastValueFrom } from 'rxjs';

import useRequest from '@swf/core/hooks/useRequest';

import { fetchToken } from './utils';

export const useRequestToken = () => {
  const request = useRequest();

  return async () => {
    const { body } = await lastValueFrom(fetchToken(request));
    return body.token;
  };
};
